import styles from '@/styles/Info.module.scss'
import BaseLayout from '@/layout/BaseLayout/BaseLayout'
import Head from 'next/head'
import React from 'react'
import { GetStaticProps } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useTranslation } from 'next-i18next'
import Hero from '@/components/common/Hero/Hero'
import ContactForm from '@/components/common/ContactForm/ContactForm'
import classNames from 'classnames'
import Raw from '@/components/common/Raw/Raw'
import { getPageTitle } from '@/utils/helpers'
import ContactInfo from '@/components/common/ContactInfo/ContactInfo'

type Props = {}

const Reseller = (props: Props) => {
  const { t } = useTranslation('reseller')

  return (
    <BaseLayout>
      <Head>
        <title>{getPageTitle(t('title'))}</title>
      </Head>
      <Hero />
      <main className={classNames(styles.info, styles.split)}>
        <div>
          <h1>{t('description')}</h1>
          <Raw
            content={t('text')}
            tagName={'p'}
          />
          <p>
            {t('sendRequest')}
          </p>
          <ContactInfo />
        </div>
        <div>
          <ContactForm />
        </div>
      </main>
    </BaseLayout>
  )
}

export default Reseller

export const getStaticProps: GetStaticProps<Props> = async ({
  locale,
}) => ({
  props: {
    ...(await serverSideTranslations(locale ?? 'en', [
      'common',
      'reseller',
      'footer'
    ])),
  },
})